import React, { Fragment } from "react";
import Form from "../common/Form";
import Row from "../common/Row";
import PropTypes from "prop-types";

const KlachtBevestigingForm = () => {

    return (
        <Fragment>
            <Form
                name="klachten"
                isNotRequired
                headerVisible={false}>
                <div style={{ padding: "25px" }}>
                    <Row>
                        <p>Beste, <br /><br /> We hebben jouw klacht goed ontvangen en zullen deze met de uiterste zorg behandelen.<br />Je krijgt van ons een antwoord binnen de wettelijk voorziene termijn van 45 dagen.<br /><br />Met vriendelijke groeten,<br />Klachtencoördinator Sport Vlaanderen</p>
                    </Row>
                </div>
            </Form>
        </Fragment>
    );
};

KlachtBevestigingForm.propTypes = {
};

export default KlachtBevestigingForm;